import React from 'react';
import _ from 'lodash';
import withClickOutsideOnOverlay from '../../../../hoc/withClickOutsideOnOverlay';
import { validateTagName } from '../../../../services/validations/validateTagName';
import BasicFormWithValidation from '../../../forms/BasicFormWithValidation';
import {FormWithCancelButton} from '../../../forms/FormWithCancelButton';

class RenameProjectTagForm extends FormWithCancelButton {

    validateTagName = ({ tagName }) => {
        const { project, selectedStageTagId } = this.props;

        return validateTagName(tagName, project, selectedStageTagId);
    }

    ok = ({ tagName }) => {
        const { project, tagId, environment } = this.props;
        const existingTagName = this.props.tagName;

        if (tagName === existingTagName) {
            this.cancel();
        } else {
            this.props.renameTag(project, tagId, tagName, environment);
            this.props.onClose();
        }
    }

    render() {
        const { tagName } = this.props;
        return <BasicFormWithValidation
            title="Rename Version"
            type="rename"
            hasCloseIcon={true}
            className="rename-project-tag-form"
            inputs={[{
                name: 'tagName',
                label: 'Version name',
                autoFocus: true,
                maxLength: 50,
                maxLengthMsg: `Max version length: 50 characters`,
                value: tagName,
                rules: [this.validateTagName],
                applyOnEnter: true
            }]}
            okButton={{
                label: 'Rename',
                action: this.ok
            }}
            cancelButton={{
                label: 'Cancel',
                action: this.cancel,
            }}
        />;
    }
}

export default withClickOutsideOnOverlay(RenameProjectTagForm);
